import { get } from 'lodash'

import type { Dimension, PriceTypes } from '../types/flyout'

export const getPricesArray = (dimensions: Dimension[]) => {
  let pricesArray: string[] = []
  const dimension = dimensions.find(
    dimensionItem => !dimensionItem.isAdditionalUsageAllowed
  )
  if (dimension?.prices) {
    const prices = dimension.prices as PriceTypes
    pricesArray = (Object.keys(prices) as (keyof PriceTypes)[]).filter(
      (price: keyof PriceTypes) => prices[price] !== null
    )
  }
  return pricesArray
}

export const getPriceQuantityTotal = (
  dimension: Dimension,
  prices: string[]
) => {
  return prices.reduce(
    (acc, next) =>
      acc + get(dimension, 'quantity', 0) * get(dimension?.prices, next, 0),
    0
  )
}

export const getCustomPriceQuantityTotal = (dimension: Dimension) => {
  return (dimension?.quantity || 0) * ((dimension?.price as number) || 0)
}
